import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  buildIntellectualPropertyCatalogState,
  withIntellectualPropertyCatalogSearch,
} from "../../../../../utils/navigationContext";
import { useIntellectualPropertyReport } from "../../hooks/useIntellectualPropertyReport";
import IntellectualPropertyReportView from "./IntellectualPropertyReportView";

const IntellectualPropertyReportContainer = ({ clientId }) => {
  const navigate = useNavigate();
  const reportState = useIntellectualPropertyReport({ clientId });

  const handleRowClick = useCallback(
    (item) => {
      if (!item?.nav_id) return;
      const detailPath = `/quan-ly-dich-vu-khach-hang/ho-so/${item.nav_id}`;

      if (clientId) {
        navigate(detailPath);
        return;
      }

      navigate(withIntellectualPropertyCatalogSearch(detailPath), {
        state: buildIntellectualPropertyCatalogState(),
      });
    },
    [clientId, navigate],
  );

  return (
    <IntellectualPropertyReportView
      {...reportState}
      onRowClick={handleRowClick}
    />
  );
};

export default IntellectualPropertyReportContainer;
